export default __webpack_public_path__ + "static/media/kristina_savova_s.f952dabf.jpg";